import { createCrmEnrichmentFiltersService } from "./factory";

const crmEnrichmentFiltersService = createCrmEnrichmentFiltersService();

export default crmEnrichmentFiltersService;
